module.exports = __webpack_public_path__ + "img/NL120.23c5145a.svg";